import React from 'react';
import Carousel from './Carousel';
import BrandSection from '../pages/BrandSection';
import PopularCarsSection from '../pages/PopularCarsSection';
import WhyChooseUsSection from '../pages/WhyChooseUsSection';
import GallerySection from '../pages/GallerySection';
import BlogSection from '../pages/BlogSection';
import Sliderr from './Slider';
import Testimonials from '../pages/Testimonials';
import CityDestinations from '../pages/CityDestinations';
import VendorPartnerForm from '../pages/VendorPartnerForm';




const HeroSection = () => {
  
  return (


    <div className="th-hero-wrapper hero-1" id="hero">


<Sliderr/>

 {/* <Carousel/> */}
<BrandSection/>
<VendorPartnerForm/>

<CityDestinations/>

<PopularCarsSection/>
<WhyChooseUsSection/>
<GallerySection/>
<Testimonials/>
<BlogSection/>
    </div>
  );
};

export default HeroSection;
